module.exports = __webpack_public_path__ + "img/declare.1f7ddbc0.png";